/**
* getSubObjectProperty
* Returns the sub property value
**/
export const getSubObjectProperty = (arrProperties, object) => {
  if(object === undefined) return;
  if(arrProperties.length === 0) return object;

  const property = arrProperties.shift();
  switch(arrProperties.length) {
    case 0:
      return (object !== undefined && object[property] !== undefined && object[property] !== null) ? object[property] : "";
    default:
      object = object[property];
      return object ? getSubObjectProperty(arrProperties, object) : "";
  }
}

export const cloneObject = (obj) => {
  var newObj = {};

  for(var key in obj) {
    if(obj.hasOwnProperty(key)) {
      newObj[key] = obj[key];
    }
  }

  return newObj;
}

export const csvToArray = (text, delimiter) => {
  if(delimiter === undefined) delimiter = ";";

  let p = '', row = [''], ret = [row], i = 0, r = 0, s = !0, l;
    for (l in text) {
        l = text[l];
        if ('"' === l) {
            if (s && l === p) row[i] += l;
            s = !s;
        } else if (delimiter === l && s) l = row[++i] = '';
        else if ('\n' === l && s) {
            if ('\r' === p) row[i] = row[i].slice(0, -1);
            row = ret[++r] = [l = '']; i = 0;
        } else row[i] += l;
        p = l;
    }
  return ret;
}

export const arrayToCsv = (array, delimiter) => {

  if(delimiter === undefined) delimiter = ";";
  const charset = "\uFEFF";
  let csvContent = "";

  if(array instanceof Array) {
    array.forEach(
      (arr, index) => {
        let data = arr.join(delimiter);

        data=data.split('\n').join(' ')
        console.log(data);
        csvContent += index < array.length ? data + "\n" : data;
      }
    );
  }

  csvContent = charset + csvContent;
  return csvContent;
}

export const downloadCsv = (csv, name) => {
  const csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});

  if (navigator.appVersion.toString().indexOf('.NET') > 0)
    window.navigator.msSaveBlob(csvData, `${name}.csv`);
  else {
    const csvURL = window.URL.createObjectURL(csvData);
    let tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', `${name}.csv`);
    tempLink.setAttribute("id", `download${name}`);
    document.body.appendChild(tempLink); // Required for FF
    tempLink.click();
    document.body.removeChild(tempLink);
  }
}



// WEBPACK FOOTER //
// ./src/Utils/Utils.js